import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.color['gray-100']};
  padding: ${rem(30)} ${rem(18)} ${rem(60)};
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: ${rem(6)};
  margin-bottom: ${rem(12)};
`;
